import { BarcodeOutlined } from "@ant-design/icons";
import { Button, Modal, Row, Col } from "antd";
import React from "react";
import palletSticker from "../../../../static/pdf/pallet-stickers/pallet-sticker";

interface PalletBarcodeModalProps {
  visible: boolean;
  onClose: () => void;
  palletNos: string[];
}

const PalletBarcodeModal = (props: PalletBarcodeModalProps) => {
  const { visible, onClose, palletNos } = props;

  const onPrint = () => {
    if (palletNos && palletNos.length > 0) {
      palletSticker(palletNos, 'print');
    }
  };

  const onPreview = () => {
    if (palletNos && palletNos.length > 0) {
      palletSticker(palletNos, 'view');
    }
  };

  return (
    <Modal
      width={600}
      destroyOnClose={true}
      visible={visible}
      title="Pallet Barcode Information"
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button key="preview" type="default" onClick={onPreview}>
          Preview
        </Button>,
        <Button key="print" type="primary" onClick={onPrint}>
          Print Barcode
        </Button>,
      ]}
    >
      <h3>Pallet Numbers:</h3>
      <p style={{ fontSize: '16px', color: '#1890ff', fontWeight: 500, marginTop: '8px' }}>
        ALL PRODUCT HAS BEEN RELOCATED TO:
      </p>
      <div style={{ marginTop: '16px' }}>
        <Row gutter={[16, 16]}>
          {palletNos?.map((palletNo: string) => (
            <Col span={12} key={palletNo}>
              <div style={{
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                padding: '12px',
                textAlign: 'center',
                backgroundColor: '#fafafa'
              }}>
                <BarcodeOutlined style={{ fontSize: '18px', color: '#1890ff', marginRight: '8px' }} />
                <span style={{ fontSize: '16px', fontWeight: 500 }}>{palletNo}</span>
              </div>
            </Col>
          ))}
        </Row>
      </div>
      {palletNos?.length === 0 && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
          No pallet numbers available
        </div>
      )}
    </Modal>
  );
};

export default PalletBarcodeModal;
